////////LIBRARY/////////
import React from 'react'
import styled from 'styled-components'
///////COMPONENTS///////
import NavHeader from './NavHeader'
import BreadCrumb from './BreadCrumb'

/////////STYLED/////////
const Container = styled.div`
	display: flex;
	flex-direction: column;
	position: fixed;
	top: 0px;
	z-index: 52;
	width: 100%;
	height: 124px;
`
/////////STYLED/////////

const Header = ({ breadCrumb, firstParent }) => {
	///////////////////////////////// RENDER ///////////////////////////////////////
	return (
		<Container>
			<NavHeader />
			<BreadCrumb breadCrumbs={breadCrumb} firstParent={firstParent} />
		</Container>
	)
}

Header.propTypes = {}

export default Header
